import Vue from 'vue';
import VueI18nManager from 'vue-i18n-manager';
import store from '@/store';
import router from '@/router';

import { DEFAULT_LOCALE, SUPPORT_LOCALES } from '@/locales/locales.js';
import { ru, ua } from '@/locales/lang';
import { $http } from '@/utils/https';

let translations = { ru, ua };

const proxy = {
  getTranslation: async ({ translationKey, code }) => {
    try {
      $http.get('v1/translations').then((response) => {
        store.dispatch('vue-i18n-manager/ADD_TRANSLATION', { translation: response.data, code });
        store.commit('setting/SET_TRANSLATIONS', response.data);
      });
      return {};
    } catch (e) {
      console.error(e);
      return translations[translationKey];
    }
  }
};

const _getHackCodeLang = () => {
  let urlLang = window.location.pathname.split('/')[1];
  let findLang = SUPPORT_LOCALES.find((item) => item.urlPrefix === urlLang);

  return findLang?.code || DEFAULT_LOCALE;
};

Vue.use(VueI18nManager, {
  store,
  router,
  proxy,
  config: {
    defaultCode: _getHackCodeLang(),
    languages: SUPPORT_LOCALES
  }
});

export const i18nManager = async () => {
  return Vue.initI18nManager();
};
